import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

export const FavoriteTeamBodyTitleSkeleton = () => {
  return (
    <>
      <Skeleton.Avatar
        active
        style={{
          width: 24,
          height: 24
        }}
      />
      <Skeleton.Button
        active
        style={{
          width: 200,
          height: 24,
          margin: '0 8px'
        }}
      />
    </>
  );
};
